<template>
  <div class="dot-question">
    <div class="container">
      <div class="top-row">
        <p class="page-title">Introduction: Heat Capacity</p>
      </div>

      <div class="question-contain">
        <h2 class="question">Which Particles Are Moving Faster?</h2>

        <div class="answers">
          <div 
          v-for="(answer, index) of answers" 
          :key="answer.id" @click="pickAnswer(index)" 
          :class="{'picked' : index === chosen}" 
          class="answer"
          :style="{pointerEvents: answered === true ? 'none' : 'auto' }">
            <p class="text">{{answer.text}}</p>
            <Dots :fill="answer.fill" :wiggle="answer.wiggle" :w="150" :h="150" :r="40" />
          </div>
        </div>

        <div class="explination-contain">
          <transition name="fade">
            <p class="explination" v-if="answered">
              The particles in Substance A are moving faster because their temperature is higher.
            </p>
          </transition>

        </div>

        <button class="btn" @click="answered === false ? checkAnswer() : moveOn()" :disabled="chosen === null">
          {{ answered === true ? 'Continue &RightArrow;' : 'Submit Answer' }}
        </button>
        
      </div>
    </div>
  </div>
</template>


<script>
import Dots from '../components/Dots'
export default {
  name:"WhatChanged",
  components:{
    Dots
  },
  data() {
    return {
      chosen: null,
      answered: false,
      answers: [
        {
          id: 1,
          text: 'Substance A',
          fill: 'orange',
          correct: true,
          wiggle: 1.5
        },
        {
          id: 2,
          text: 'Substance B',
          fill: 'yellow',
          correct: false,
          wiggle: 1.2
        },
      ]
    }
  },
  methods: {
    pickAnswer(i){
      if(this.answered !== true) this.chosen = i
    },
    checkAnswer(){
      this.answered = true
    },
    moveOn(){
      this.$router.push('/review/equation')
    }
  },
}
</script>


<style lang="scss">
  .container{
    max-width: 80rem;
    margin: 0 auto;
    padding: 3rem;

    .top-row{
      .title{
        text-align-last: left;
        padding: 3rem 3rem 2rem;
        text-transform: uppercase;
        font-weight: bold;
        color: $grey;
      }
    }

    .question-contain{
      margin-top: 5rem;
      
      .question{
        font-size: 2rem;
        font-weight: bold;
        margin-top: 5rem;
      }

      .explination-contain{
        max-width: 35rem;
        height: 3rem;
        margin: 2rem auto 1rem;
      }
    }
  }

  .answers{
    display: grid;
    grid-template-columns: 12.8rem 12.8rem;
    grid-gap: 2rem;
    margin: 0 auto;
    width: 27.6rem;

    .answer{
      min-height: 12.8rem;
      box-shadow: 2px 2px 5px rgba($dark, 0.5);
      cursor: pointer;
      

      .text{
        background: $light;
        margin: 0;
        padding: 1rem;
        margin-bottom: 1rem;
        transition: all 250ms;
      }

      &:hover{
        .text{
          background: $blue;
          color: #ffffff;
        }
      }

      &.picked{
        .text{
          background: $green;
          color: #ffffff;
        }
      }
    }
  }
</style>